import React from "react";
import styles from "./StatsSection.module.css";
import { StatsCard } from "./StatsCard";
import { StatsGrid } from "./StatsGrid";
import { formatCurrency } from "../../utils";
import Dropdown from "../commons/Dropdown";
import SkeletonCard from "../skeletons/SkeletonCard";

// --- Helpers ---
const getMonthlyLabel = () => {
  const now = new Date();
  const month = now.toLocaleString("en-US", { month: "short" });
  const year = now.getFullYear();
  return `Monthly Profit (${month} ${year})`;
};

const getWeeklyLabel = () => {
  const now = new Date();
  const day = now.getDay(); // 0 = Sun
  const diffToMonday = day === 0 ? -6 : 1 - day;

  const monday = new Date(now);
  monday.setDate(now.getDate() + diffToMonday);

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const format = (d) =>
    `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1
    ).padStart(2, "0")}`;

  return `Weekly Profit (${format(monday)} - ${format(sunday)})`;
};

export const StatsSection = ({
  dashboard,
  exchanges,
  selectedExchange,
  setSelectedExchange,
  loading,
}) => {
  return (
    <div className="">
      <div className="mt-3">
        <h2 className="text-xl md:text-2xl font-bold text-gray-900 my-0 py-0">
          Your Asset Overview
        </h2>
        <p className="text-sm md:text-base text-[#21272A]/60 mt-1 py-0 mb-5">
          Track your overall performance across exchanges – profits, trends, and
          top-performing bots, all in one place.
        </p>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-5 xl:flex-row xl:items-center gap-4 p-4 py-5 bg-white rounded-lg">
        <Dropdown
          id="exchange"
          placeholder="All Exchange"
          value={selectedExchange}
          onChange={(val) => setSelectedExchange(val)}
          style="group"
          options={[{ id: "", name: "All Exchange" }, ...exchanges]}
          className={"shadow-none !border-none !p-0"}
          classNameInput={"!text-[22px]"}
        />

        <div className="xl:col-span-4 grid xl:grid-cols-4 gap-4">
          {[
            {
              label: "Aggregate Account Balance",
              sub: "",
              value: `${formatCurrency(
                dashboard?.summary?.aggregate_balance_usdt || 0
              )} USDT`,
            },
            {
              label: "Total Profit",
              sub: "",
              value: `${formatCurrency(
                dashboard?.summary?.total_profit || 0
              )} USDT`,
            },
            {
              label: getMonthlyLabel(), // ADDED
              value: `${formatCurrency(
                dashboard?.summary?.monthly_profit || 0
              )} USDT`,
            },
            {
              label: getWeeklyLabel(), // ADDED
              value: `${formatCurrency(
                dashboard?.summary?.weekly_profit || 0
              )} USDT`,
            },
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white flex flex-col justify-center rounded-2xl px-4 py-3 shadow-sm border border-gray-200"
            >
              <p
                className="text-sm text-gray-500 font-normal !py-0 !m-0 truncate max-w-[180px]"
                title={item.label}
              >
                {item.label}
              </p>

              <p className="text-2xl font-semibold text-gray-900 !py-0 !m-0 !mt-1">
                {loading ? (
                  <SkeletonCard
                    type="text"
                    lines={2}
                    widths={["0", "100px"]}
                    heights={["0", "20px"]}
                  />
                ) : (
                  item.value
                )}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
